import ChipRow from "./chip-row";
import { studioHistoryUrl } from "../studio-link";

// Shares the `.mood` slide-up sheet styling, like Skins, Advanced and
// Feedback. The chips are links: a host with its own way of opening pages
// (the extension's popup, the web panel's parent) takes over through the
// click handlers; without one they open like any other link.
export default function StudioSheet({
  open,
  studioUrl,
  studioSaveUrl = null,
  onOpenClick,
  onSaveClick,
  onHistoryClick,
}) {
  const historyUrl = studioHistoryUrl(studioUrl);
  const items = [
    ...(studioSaveUrl
      ? [
          {
            key: "save",
            label: "Save Song",
            title: "Keep this song in your Studio playlist, with this sound",
            href: studioSaveUrl,
            onClick: onSaveClick ? () => onSaveClick(studioSaveUrl) : null,
          },
        ]
      : []),
    {
      key: "open",
      label: "Open Player",
      title: "Open Slowed Studio, your player",
      href: studioUrl,
      onClick: onOpenClick ? () => onOpenClick() : null,
    },
    ...(historyUrl
      ? [
          {
            key: "history",
            label: "Show History",
            title: "The songs you last used Slowed on, in Studio's player",
            href: historyUrl,
            onClick: onHistoryClick ? () => onHistoryClick(historyUrl) : null,
          },
        ]
      : []),
  ];

  return (
    <div
      id="mood-sheet"
      className={`mood mood--studio${open ? " mood--open" : ""}`}
      aria-label="Studio"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Studio</div>
        <p className="mood__subtitle">
          Your slowed + reverb player, for your own songs.
        </p>
      </div>

      <ChipRow>
        {items.map((item) => (
          <a
            key={item.key}
            className="mood__chip"
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            title={item.title}
            tabIndex={open ? 0 : -1}
            onClick={(event) => {
              if (!item.onClick) return;
              event.preventDefault();
              item.onClick();
            }}
          >
            <span className="mood__chip-name">{item.label}</span>
          </a>
        ))}
      </ChipRow>
    </div>
  );
}
